import { graphql } from '../../gql';

// Query to get paginated product image connection
export const PRODUCT_IMAGE_CONNECTION_QUERY = graphql(`
  query productImageConnection(
    $productId: ID
    $first: Int
    $after: String
    $last: Int
    $before: String
    $filter: String
    $selectedImageIds: [ID!]
  ) {
    productImageConnection(
      productId: $productId
      first: $first
      after: $after
      last: $last
      before: $before
      filter: $filter
      selectedImageIds: $selectedImageIds
    ) {
      edges {
        cursor
        node {
          id
          displayName
          createdAt
          image {
            id
            url
            altText
            width
            height
            thumbnailUrl
          }
          isFeatured
          order
          isConnected
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      count
    }
  }
`);

// Mutation to add a product image
export const ADD_PRODUCT_IMAGE_MUTATION = graphql(`
  mutation addProductImage($image: Upload!) {
    addProductImage(image: $image) {
      id
      url
      altText
      width
      height
      thumbnailUrl
    }
  }
`);
